<div class="page-container">

  <a mat-button
     routerLink="/statistics"
     [state]="{ restoreSearch: true }"
     class="back-button">
    <mat-icon>arrow_back</mat-icon>
    Volver al buscador
  </a>

  <div *ngIf="isLoading$ | async" class="main-loader-container">
    <mat-spinner diameter="60"></mat-spinner>
    <span>Cargando perfil del jugador...</span>
  </div>

  <div *ngIf="!(isLoading$ | async)" class="page-content">

    <app-player-detail-header
      [profile]="playerProfile$ | async">
    </app-player-detail-header>

    <app-player-stats-dashboard
      [seasons]="playerSeasons$ | async"
      [stats]="selectedSeasonStats$ | async"
      [isLoadingStats]="isLoadingStats$ | async"
      (seasonChanged)="onSeasonChange($event)">
    </app-player-stats-dashboard>

  </div>
</div>
